import * as React from 'react';
import { observer } from 'mobx-react';

import Modal from '../../../../../Modal';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';

export interface Props {
  modalStore: ModalStore;
}

const VideoProjectFeedbackModal: React.FC<Props> = ({ modalStore }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Video Project Feedback" />
            </h3>
          }
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <p className="pb-4">
            <T kind="Each time a participant completes a..." />
          </p>
        </Modal>
      );
  }
};

export default observer(VideoProjectFeedbackModal);
